module.exports = __webpack_public_path__ + "assets/img/2018_4.45617b19.png";